import React, { Component } from 'react';
import { hashHistory } from 'react-router';
import Relay from 'react-relay';
import Config from '../../Config.js';

import NetworkLayer from '../../NetworkLayer';
import RelayStore from '../../RelayStore';

class Login extends Component {
  constructor() {
    super();

    this.state = {
      username: '',
      password: ''
    };
  }

  updateEmail = (e) => {
    this.setState({
      username: e.target.value
    });
  }

  updatePassword = (e) => {
    this.setState({
      password: e.target.value
    });
  }

  login = () => {
    if (!this.state.username || !this.state.password) { 
      alert("Missing email or password");
      return ;
    }
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');

    fetch(Config.authUrl, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        email: this.state.username,
        password: this.state.password,
      })
    }).then((response) => response.json())
      .then((userData) => {
        console.log(userData);
        if (!userData.success) {
          alert(userData.msg);
          return;
        }
        localStorage.setItem('authToken', userData.token);
        
        const networkLayer = new NetworkLayer(
          Config.backendUrl, {
            headers: {
              token: userData.token,
            },
        });
        networkLayer.setToken(userData.token);
        RelayStore.reset(networkLayer);

        
        let path = '/dashboard';
        this.props.router.push({
          pathname : path
        });
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  
  render() {
    return (
      <div style={{width: 450, margin:"auto", textAlign: "center", display:"flex", flexDirection:"column"}}>
        <h3>Login</h3>
        <div style={{display: "flex", flexDirection:"row", marginTop:25, alignItems:"center"}}>
          <label style={{flex: 1}}>Email</label>
          <input
            className="form-control"
            style={{marginLeft:20, flex: 5}}
            type="text"
            name="username"
            placeholder="Email"
            value={this.state.username}
            onChange={this.updateEmail}
          />
        </div>
        <div style={{display: "flex", flexDirection:"row", marginTop:25, alignItems:"center"}}>
          <label style={{flex: 1}}>Password</label>
          <input
            className="form-control"
            style={{marginLeft:20, flex: 5}}
            type="password"
            name="password"
            placeholder="Password"
            value={this.state.password}
            onChange={this.updatePassword}
          />
        </div>
        <button 
          style={{marginTop:25}}
          className="btn btn-default"
          onClick={this.login}>
          SUBMIT
        </button>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login/LoginPage.js